const config = {
    build_number: '616928',
    build_timestamp: '2026-10-13T23:17:39.766Z',
    build_commit: 'b206d2cf41a3242b4faf4969e31ba07c826ee69c',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
